import { Form, Select } from 'antd';
import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useAuthHeader } from '../Services/Auth/sessionAuth';

import DataSelect from '../Types/DataSelect';
import ParamsPicklist from '../Types/ParamsPicklist';
import Datas from "../Data/Data.json";
import { Crypter } from '../Functions/Security/Crypter';

interface SelectOptionProps {
  disabled?: boolean;
  Size?: any;
  label: string;
  name: string;
  width?: number;
  widthl?: number;
  taille?: number | string;
  Option?: DataSelect[];
  onchange?: (value: any) => void;
  notRequired?: boolean;
  Parametre?: ParamsPicklist;
  DefaulValue?: any;
  icon?: any;
}

const SelectOption = (props: SelectOptionProps) => {

  const authHeader = useAuthHeader();

  const [load, setLoad] = useState(false);
  const previousParam = useRef("");

  const [data, setData] = useState<DataSelect[]>(props.Option || []
  );

  const required = !props.notRequired;

  // --- Détection d'un reset du formulaire parent (form.resetFields()) ---
  // On récupère l'instance du Form englobant (déjà présent puisque ce
  // composant est toujours rendu à l'intérieur d'un <Form>), sans avoir
  // besoin d'ajouter une prop "form" partout où SelectOption est utilisé.
  const form = Form.useFormInstance();
  const watchedValue = Form.useWatch(props.name, form);
  const prevWatchedValue = useRef(watchedValue);

  useEffect(() => {

    const previous = prevWatchedValue.current;
    prevWatchedValue.current = watchedValue;

    // Si la valeur du champ vient de revenir à sa valeur initiale
    // (cas typique d'un form.resetFields()), on vide le cache des
    // options pour forcer un rechargement propre au prochain clic,
    // sauf si les options sont statiques (props.Option fourni).
    if (
      !props.Option?.length &&
      watchedValue === props.DefaulValue &&
      previous !== props.DefaulValue
    ) {
      setData([]);
      previousParam.current = "";
    }

  }, [watchedValue]);

  // Options dynamiques (props.Option) : synchroniser `data` quand la
  // liste arrive après le montage (ex. comptes du client chargés
  // après la sélection d'une simulation).
  useEffect(() => {
    if (props.Option) {
      setData(props.Option);
    }
  }, [props.Option]);

  useEffect(() => {

  // Si options statiques → ne rien faire
  if (props.Option?.length) return;

  const current =JSON.stringify(props.Parametre);
  if (
    previousParam.current && previousParam.current !== current
  ) {
    setData([]);
  }

  previousParam.current = current;

}, [props.Parametre, props.Option]);

  const LoaData = async () => {

    if (data.length > 0 || props.Option || !props.Parametre) return;

    try {

      setLoad(true);

      const body = {
        CodeAgence: props.Parametre?.CodeAgence,
        Table: props.Parametre?.Table,
        Colonne1: props.Parametre?.Colonne1,
        Colonne2: props.Parametre?.Colonne2,
        Colagence: props.Parametre?.Colagence,
        Init: props.Parametre?.Init,
        choix: props.Parametre?.Choix,
        colfiltre: props.Parametre?.colfiltre,
        valfiltre: props.Parametre?.valfiltre
      };

      const response = await axios({
        method: 'get',
        url: Datas.ApiUrl.AnySearch,
        headers: {
          Authorization: authHeader(),
          'Content-Type': 'application/json',
          CypherSearch: Crypter.encrypt(JSON.stringify(body))
        }
      });

      if (response.data) {

        const result =
          JSON.parse(
            Crypter.decrypt(response.data)
          ).Value;

        if (
          result.StatutCode === 200 &&
          result.Result?.Table
        ) {

          const options =
            result.Result.Table.map((item: any) => ({
              value: item[Object.keys(item)[1]],
              label:
                item[Object.keys(item)[1]] +
                ' -- ' +
                item[Object.keys(item)[0]]
            }));

          setData(options);
        }
      }

    } catch (error) {

      console.log(error);

    } finally {

      setLoad(false);

    }
  };

  return (
    <Form.Item
      preserve={true}
      label={props.label}
      name={props.name}
      initialValue={props.DefaulValue}
      className="bordure"
      rules={[
        {
          required,
          message: 'Champ obligatoire'
        }
      ]}
      labelCol={{
        span: props.width,
        offset: props.widthl,
        style: {
          whiteSpace: 'pre-wrap'
        }
      }}
    >
      <Select
          suffixIcon={props.icon}
          size={props.Size}
          loading={load}
          disabled={props.disabled}
          options={data}
          showSearch
          placeholder="Search"
          maxTagCount={1}
          style={{ width: props.taille || '100%' }}
          
          onMouseDown={() => {
            if (data.length === 0) {
              LoaData();
            }
          }}

          onChange={props.onchange}

          optionFilterProp="label"

          filterOption={(input, option) =>
            String(option?.label ?? '')
              .toUpperCase()
              .includes(input.toUpperCase())
          }

          getPopupContainer={() => document.body}

          placement="bottomLeft"

          dropdownMatchSelectWidth

          dropdownStyle={{
            zIndex: 99999,
            maxHeight: 250,
            overflowY: 'auto'
          }}
        />
    </Form.Item>
  );
};

export default SelectOption;